import styled from "styled-components";
import { motion } from "framer-motion";
import { textAnimate } from "../animation";

const Project = ({ name, link, description, stacks }) => {
  return (
    <Card variants={textAnimate}>
      <a href={`http://${link}`} target="_blank" rel="noopener noreferrer">
        {name}
      </a>
      <p className="description">{description}</p>
      <div className="stack">
        {stacks.map((stack, idx) => (
          <span key={idx}>{stack}</span>
        ))}
      </div>
    </Card>
  );
};

const Card = styled(motion.div)`
  width: 100%;
  border: 2px solid #aaaaaa;
  border-radius: 5px;
  padding: 2rem 1.5rem;
  a {
    font-family: "Antonio", sans-serif;
    font-weight: 700;
    font-size: 4rem;
    overflow: hidden;
    position: relative;
    background: linear-gradient(to right, #1b9cf1, #1b9cf1 50%, #aaaaaa 50%);
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: 200% 100%;
    background-position: 100%;
    transition: background-position 0.5s ease;
    &:hover {
      background-position: 0 100%;
    }
  }

  .description {
    margin-top: 0.5rem;
  }

  .stack {
    margin-top: 1.5rem;
    span {
      font-size: 0.8rem;
      border: 1px solid #aaaaaa;
      border-radius: 5px;
      padding: 0.5rem;
      margin-right: 0.7rem;
    }
  }

  @media screen and (max-width: 600px) {
    padding: 1.5rem;
    a {
      font-size: 1.8rem;
    }

    .description {
      font-size: 0.8rem;
    }

    .stack {
      margin-top: 1rem;
      span {
        font-size: 0.5rem;
        margin-right: 0.5rem;
      }
    }
  }
`;

export default Project;
